import { combineReducers } from "redux";
import { RootState } from "../types";
import initialization from "./initialization";
import alarm from "./alarm";

export default combineReducers<RootState>({
    initialization,
    alarm,
});
